var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"epb-loader",class:{ 'epb-loader--inverse': _vm.inverse }})}
var staticRenderFns = []

export { render, staticRenderFns }